import { Flex } from "@chakra-ui/react";
import type { ResourcesProps } from "~/pages/resources";
import Footer from "../landing/v2/footer";
import Navbar from "../navbar";
import Resource from "./resource";

const ResourcePage = ({ data }: ResourcesProps) => {
  return (
    <Flex minHeight="100vh" direction="column" fontFamily="Inter">
      <Navbar />
      <Resource data={data} />
      <Footer cta />
    </Flex>
  );
};

export default ResourcePage;
